/**
 * @generated SignedSource<<717215a0220aeeb8ebda01b1295a2bb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserAvatar_gwtUser$data = {
  readonly firstName: string;
  readonly id: string;
  readonly lanId: string;
  readonly lastName: string;
  readonly " $fragmentType": "UserAvatar_gwtUser";
};
export type UserAvatar_gwtUser$key = {
  readonly " $data"?: UserAvatar_gwtUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_gwtUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAvatar_gwtUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lanId",
      "storageKey": null
    }
  ],
  "type": "GwtUser",
  "abstractKey": null
};

(node as any).hash = "4803385a6a3c7f91bd95df4857fa1106";

export default node;
